import {withRouter} from "react-router";
import {get as _get} from "lodash";

import ProductGeoRestrictionsForm from "./ProductGeoRestrictionsForm";

import {convertToInt} from "../../../utils/helpers";

class ProductLcoGeoRestrictionsForm extends ProductGeoRestrictionsForm {

    getEntityClientProductId = () => {
        return convertToInt(_get(this.props.GraphQLEntityData, 'clientProductsLco[0].id', 0));
    };

    getEntityGeoRestrictions = (entityData) => {
        return _get(entityData, 'clientProductsLco[0].client_product', {});
    };
}

export default withRouter(ProductLcoGeoRestrictionsForm);
